import React from 'react';
import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';

// Reference tool's (simuprint.vercel.app) two sidebar callouts, next to the
// intro text: a "don't replace your lab" disclaimer and a one-line formula
// explainer. Both are plain-text ACF fields (see PostTypes.php's
// `partner_lab_note` / `calculation_method_note`) with a sensible English
// default, editable per calculator instance — not WYSIWYG, since neither
// needs more than line breaks (preserved via CSS `white-space: pre-line`
// rather than converting to markup).
const InfoSidebar = ( { partnerLabNote, calculationMethod } ) => {
	if ( ! partnerLabNote && ! calculationMethod ) {
		return null;
	}

	return (
		<div className="roi-calculator__info-sidebar">
			{ partnerLabNote && (
				<div className="roi-calculator__partner-note">
					<div className="roi-calculator__partner-note-head">
						<svg
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
							aria-hidden="true"
						>
							<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
						</svg>
						{ __(
							'A note about your partner lab',
							'sprintray-roi-calculator'
						) }
					</div>
					<p className="roi-calculator__partner-note-text">
						{ partnerLabNote }
					</p>
				</div>
			) }
			{ calculationMethod && (
				<div className="roi-calculator__method-note">
					<div className="roi-calculator__method-note-head">
						{ __(
							'Calculation method',
							'sprintray-roi-calculator'
						) }
					</div>
					<code className="roi-calculator__method-note-code">
						{ calculationMethod }
					</code>
				</div>
			) }
		</div>
	);
};

InfoSidebar.propTypes = {
	partnerLabNote: PropTypes.string,
	calculationMethod: PropTypes.string,
};

export default InfoSidebar;
